import React from "react";
import {
  FaArrowAltCircleLeft,
  FaChevronUp,
  FaUser,
  FaUserAlt,
} from "react-icons/fa";

const UserMenu = ({ showUserMenu, auth, handleLogout }) => {
  return (
    showUserMenu && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          top: 85,
          right: 20,
          background: "#1e374f",
          zIndex: 10,
          boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
        }}
      >
        <div
          style={{
            padding: 10,
            display: "flex",
            gap: 10,
            alignItems: "center",
            borderBottom: "1px solid white",
            cursor: "auto",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <FaUserAlt /> {auth?.email}
        </div>
        <div
          style={{
            padding: 10,
            display: "flex",
            gap: 10,
            alignItems: "center",
          }}
          onClick={() => {
            handleLogout();
          }}
        >
          <FaArrowAltCircleLeft /> Logout
        </div>
      </div>
    )
  );
};

const UserButton = ({
  auth,
  showUserMenu,
  setShowUserMenu,
  setLoginPopupOpen,
  setLoginMode,
}) => {
  return (
    <div
      style={{
        background: "white",
        borderRadius: 50,
        padding: 8,
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
        cursor: "pointer",
      }}
      onClick={() => {
        if (!auth?.email) {
          setLoginPopupOpen(true);
          setLoginMode && setLoginMode("login");
        } else {
          setShowUserMenu(!showUserMenu);
        }
      }}
    >
      {showUserMenu ? (
        <FaChevronUp
          size={30}
          style={{
            color: "#002a52",
          }}
        />
      ) : (
        <FaUser
          size={30}
          style={{
            color: "#002a52",
          }}
        />
      )}
    </div>
  );
};

export { UserMenu, UserButton };
